import { useEffect, useRef } from "react";

export const CANVAS_ID = "Main-Canvas";

/** Not the control that opened the dialog: the selection can change while it
 *  is up, so that element may already be gone. */
export function focusCanvas(): void {
  document.getElementById(CANVAS_ID)?.focus({ preventScroll: true });
}

/** Returns focus to the canvas on the open → closed edge, and only then —
 *  a host that mounts closed must not steal focus on mount. */
export function useFocusCanvasOnClose(isOpen: boolean): void {
  const wasOpen = useRef(isOpen);
  useEffect(() => {
    if (wasOpen.current && !isOpen) focusCanvas();
    wasOpen.current = isOpen;
  }, [isOpen]);
}
